import { useLocation } from "react-router-dom";
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Routers from './Router/Routers';
import { useEffect } from 'react';

function App() {


  useEffect(() => {
    document.title = "Centerprism Survey"
    document.header = 'src/assets/primeLogo.png'
  },[])


  return (
    <div id="app">
    <Navbar/>
    <Routers/>
      
    </div>
  );
}

export default App;
